"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PageController = /*#__PURE__*/function () {
  function PageController() {
    _classCallCheck(this, PageController);

    this._body = document.getElementsByTagName("body")[0];
    this._header = document.getElementsByTagName("header")[0];
    this._footer = document.getElementsByTagName("footer")[0];
    this._content = document.getElementsByTagName("main")[0];
    this._banner = "#banner";
    this._template = $('body').data('template');
    this._countdownEl = ".countdown"; //this.mobileMenu = new MobileMenu();

    this.flashMessage = new FlashMessage();
    this.arrayUtils = new ArrayUtils();
    this.dateUtils = new DateUtils();
    this.numberUtils = new NumberUtils();
    this.stringUtils = new StringUtils();
    this.mobileMenu = new MobileMenu();
    this.footerLayout = new FooterComponent(this._header, this._footer, this._content);
    this.formAntispamAutofill();
    this.bannerOpen();
    this.searchActiveItem();
    this.countdownInformationStrip();
  }

  _createClass(PageController, [{
    key: "countdownInformationStrip",
    value: function countdownInformationStrip() {
      var _this = this;

      if ($(_this._countdownEl).length > 0) {
        $(_this._countdownEl).each(function () {
          var countDownEl = $(this);
          var countDownDate = new Date($(this).attr("data-date")).getTime();
          $(this).html(getCalculationOfCountdownBaseOnDate(countDownDate).text);
          var intUpdateCountdown = setInterval(function () {
            var countdownCalculation = getCalculationOfCountdownBaseOnDate(countDownDate);
            $(countDownEl).html(countdownCalculation.text);

            if (countdownCalculation.distance < 0) {
              clearInterval(intUpdateCountdown);
            }
          }, 1000);
        });
      }

      function getCalculationOfCountdownBaseOnDate(date) {
        // Get today's date and time
        var now = new Date().getTime(); // Find the distance between now and the count down date

        var distance = date - now; // Time calculations for days, hours, minutes and seconds

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);
        var text = "";

        if (distance < 0) {
          text = "0h 0m 0s";
        } else {
          if (days > 0) {
            text += _this.minTwoDigits(days) + "d ";
          }

          text += _this.minTwoDigits(hours) + "h " + _this.minTwoDigits(minutes) + "m " + _this.minTwoDigits(seconds) + "s ";
        }

        return {
          distance: distance,
          text: text
        };
      }
    }
  }, {
    key: "minTwoDigits",
    value: function minTwoDigits(n) {
      return (n < 10 ? '0' : '') + n;
    }
  }, {
    key: "searchActiveItem",
    value: function searchActiveItem() {
      $(".toActive").each(function (index, element) {
        var item = $(this);
        setTimeout(function () {
          item.addClass("active-find-term");
        }, 100 * index);
      });
    }
  }, {
    key: "formAntispamAutofill",
    value: function formAntispamAutofill() {
      var _this = this;

      var spamSecureField = $("#frm-contactForm-request_code");
      var currentTimestamp = new Date().getTime();

      if (spamSecureField.length) {
        setTimeout(function () {
          spamSecureField.val(currentTimestamp);
        }, 10000);
      }
    }
  }, {
    key: "bannerOpen",
    value: function bannerOpen() {
      var _this = this;

      var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

      var currentBannersRaw = _this.getCookie("banner");

      var currentBanners = [];

      if (currentBannersRaw !== null) {
        currentBanners = JSON.parse(currentBannersRaw);
      }

      if (hash === "confirmbanner") {
        if (!currentBanners.includes($(_this._banner).attr("data-id"))) {
          currentBanners.push($(_this._banner).attr("data-id"));

          _this.setCookie("banner", JSON.stringify(currentBanners), 1);
        }
      } else {
        if ($(_this._banner).length === 1) {
          if (!currentBanners.includes($(_this._banner).attr("data-id"))) {
            $(_this._banner).fancybox({
              afterShow: function afterShow() {
                $(".fancybox-image").wrap($("<a />", {
                  // set anchor attributes
                  href: $(_this._banner).attr("data-link"),
                  //or your target link
                  target: "_blank" // optional

                }));
              },
              afterClose: function afterClose() {
                if (!currentBanners.includes($(_this._banner).attr("data-id"))) {
                  currentBanners.push($(_this._banner).attr("data-id"));

                  _this.setCookie("banner", JSON.stringify(currentBanners), 1);
                }
              },
              buttons: ["close"]
            }).trigger('click');
          }
        }
      }
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value, days) {
      var expires = "";

      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }

      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }

      return null;
    }
  }, {
    key: "eraseCookie",
    value: function eraseCookie(name) {
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }]);

  return PageController;
}();